// src/services/CountryService.js
import api from "./api";

export function getAccommodationType(page = 1, limit = 10, search = "") {
  return api.get(
    `/accommodationtype?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getAccommodationTypeById(id) {
  return api.get(`/accommodationtype/${id}`);
}

export function addAccommodationType(data) {
  return api.post("/accommodationtype", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateAccommodationType(id, data) {
  return api.put(`/accommodationtype/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteAccommodationType(id) {
  return api.delete(`/accommodationtype/${id}`);
}
